import React from 'react'
import { number, string, bool, func } from 'prop-types'

import Link from 'src/common/components/link'
import classNames from 'src/common/helpers/class-names'

import { RatingStars } from './rating-stars'

import './_style.scss'

const blk = 'co-product'

const Rating = (props) => {
  const {
    itemUrl,
    className,
    mix,
    size,
    avgStarRating,
    show,
    totalReviewCount,
    clickHandler,
  } = props

  const reviewCount = totalReviewCount > 50 ? '50+' : totalReviewCount
  if (!reviewCount || !show) return null

  const getRatingPercent = () => (avgStarRating / 5) * 100

  const getCountText = reviews => ['(', reviews, ')'].join('')

  const reviewCountClass = classNames({
    blk,
    elt: 'review-count',
    mix,
    mods: [size],
  })

  const ratingBaseClass = classNames({
    className: className || mix,
    blk,
    elt: 'rating',
  })

  return (
    <Link
      dataAutoId='linkProductRating'
      className={ratingBaseClass}
      href={itemUrl}
      asAnchor
      target='_blank'
      rel='noopener noreferrer'
      onClick={clickHandler}
    >
      <RatingStars
        reviewCount={reviewCount}
        avgStarRating={avgStarRating}
        percentage={getRatingPercent()}
        mix={mix}
        size={size}
      />
      <span className={reviewCountClass} aria-hidden='true'>
        {getCountText(reviewCount)}
      </span>
    </Link>
  )
}

Rating.propTypes = {
  itemUrl: string,
  className: string,
  mix: string,
  size: string,
  avgStarRating: number,
  show: bool,
  totalReviewCount: number,
  clickHandler: func,
}

Rating.defaultProps = {
  itemUrl: '',
  className: '',
  mix: undefined,
  size: undefined,
  avgStarRating: null,
  show: true,
  totalReviewCount: 0,
  clickHandler: () => {},
}

export default Rating



// WEBPACK FOOTER //
// ./shared/interim/product/rating/index.js